import React, { useState, useEffect, useContext } from "react";
import { AppContext } from "../Context/Provider";
import { Link } from "react-router-dom";

const Carousel = () => {
  const { HomeSlider, FetchHomeSlider } = useContext(AppContext);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    FetchHomeSlider();
  }, []);

  useEffect(() => {
    if (HomeSlider?.length) {
      setIsInitialLoad(false);
    }
  }, [HomeSlider]);

  useEffect(() => {
    if (!HomeSlider?.length) return;

    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % HomeSlider.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [HomeSlider]);

  const goToSlide = (index) => {
    setActiveIndex(index);
  };

  const nextSlide = () => {
    setActiveIndex((prev) => (prev + 1) % HomeSlider.length);
  };

  const prevSlide = () => {
    setActiveIndex((prev) => (prev === 0 ? HomeSlider.length - 1 : prev - 1));
  };

  if (isInitialLoad) {
    return (
      <section className="w-full min-h-[70vh] flex justify-center items-center ">
        <div className="  border-4 border-[#5cb85c] border-t-transparent" />
      </section>
    );
  }

  if (!HomeSlider || HomeSlider.length === 0) {
    return (
      <section className="w-full min-h-[70vh] flex justify-center items-center bg-gray-100">
        <div className="text-center">
          <p className="text-gray-600 mb-4">No slides available</p>
          <Link
            to="/"
            className="bg-[#5cb85c] px-6 py-3 rounded text-white hover:bg-green-600 transition-colors"
          >
            Return Home
          </Link>
        </div>
      </section>
    );
  }

  const activeSlide = HomeSlider[activeIndex];
  const imageUrl = activeSlide?.fileName || "";

  return (
    <section
      className="relative w-full min-h-[60vh] md:min-h-[90vh] overflow-hidden  "
      aria-label="Image carousel"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center transition-all duration-700 ease-in-out"
        style={{
          backgroundImage: `url('${imageUrl}')`,
        }}
      />

      {/* Dark Muted Overlay for Design Accuracy */}
      <div className="absolute inset-0 bg-black/50  " />

      {/* Content Alignment: Left-aligned as per image */}
      {/* Content Alignment – MATCHES NAVBAR WIDTH */}
      <div
        className="
    relative
    z-10
    flex
    items-center
    min-h-[calc(100vh-88px)]
    pt-[88px]
    text-white
  "
      >
        {/* SAME container as Navbar */}
        <div className="max-w-screen-xl mx-auto w-full px-4">
          <div className="max-w-3xl text-left">
            {/* Title */}
            {activeSlide?.title && (
              <h1
                className="text-4xl md:text-6xl font-bold mb-4 leading-tight"
                dangerouslySetInnerHTML={{ __html: activeSlide.title }}
              />
            )}

            {/* Description */}
            {activeSlide?.description && (
              <p
                className="mb-10 max-w-xl text-base md:text-lg text-gray-200 leading-relaxed"
                dangerouslySetInnerHTML={{ __html: activeSlide.description }}
              />
            )}

            {/* Buttons */}
            <div className="flex gap-4 mb-12">
        <a
  href="https://youtu.be/-znn4cQlfV4"
  target="_blank"
  rel="noopener noreferrer"
  className="flex items-center gap-2 bg-[#5cb85c] hover:bg-green-600 text-white px-8 py-3 rounded-full font-bold transition-all duration-300"
>
  Get Started Now
  <svg
    className="w-5 h-5"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
      d="M17 8l4 4m0 0l-4 4m4-4H3"
    />
  </svg>
</a>


              <Link
                to={activeSlide?.supportLink || "/support"}
                className="bg-white hover:bg-gray-100 text-gray-800 px-8 py-3 rounded-full font-bold transition-all duration-300"
              >
                Learn Service
              </Link>
            </div>

            {/* Indicators */}
            {HomeSlider.length > 1 && (
              <div className="flex items-center gap-3">
                {HomeSlider.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => goToSlide(index)}
                    className={`h-2.5 rounded-sm transition-all duration-500 ${
                      index === activeIndex
                        ? "bg-[#5cb85c] w-20"
                        : "bg-white w-8"
                    }`}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Navigation Arrows (optional) */}
      {HomeSlider.length > 1 && (
        <>
          <button
            onClick={prevSlide}
            className="absolute left-4 top-1/2 -translate-y-1/2 z-20 p-3 rounded-full bg-black/30 hover:bg-black/50 text-white transition-colors"
            aria-label="Previous slide"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-4 top-1/2 -translate-y-1/2 z-20 p-3 rounded-full bg-black/30 hover:bg-black/50 text-white transition-colors"
            aria-label="Next slide"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </>
      )}

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
};

export default Carousel;
